import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Box, MenuItem, Paper, Stack, TextField } from '@mui/material';
import { ProspectLeadsTableHeader } from './components/ProspectLeadsTableHeader';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import ProspectLeadAddEdit from './components/ProspectLeadAddEdit';
import ProspectLeadsBulkUpload from './components/ProspectLeadsBulkUpload';
import AssignButton from './components/AssignButton';
import GlobalTable from '../../components/CustomTableWithPagination/GlobalTable';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getProspectLeadsTable, getProspectLeadStatuses } from '../../redux/features/globalSlice';
import GlobalDialog from '../../components/mui/Dialogue/GlobalDialog';
import { DeleteButton } from '../../components/mui/Buttons/Buttons';
import LeadStatusUpdate from './components/LeadStatusUpdate';
import LeadTransferUpdate from './components/LeadTransferUpdate';
import LeadAssignUpdate from './components/LeadAssignUpdate';
import LeadViewHisory from './components/LeadViewHisory';
import { prospect_leads_departments } from '../../utils/constants/departmentDetails';
import { getClass, getSyllabus } from '../../redux/features/deoSlice';
import { project } from '../../utils/constants/project';

const ProspectLeads = () => {
  const dispatch = useDispatch();
  const profile = JSON.parse(localStorage.getItem('cred')).profile;
  const { departmentId, isHod, isReportingHead } = profile;
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [selectedProject, setSelectedProject] = useState('all');

  const isDeptOgdOrCsd = prospect_leads_departments.map((item) => item.id).includes(departmentId);
  const { data, meta, loading } = useSelector((state) => state.global.prospectLeadTable);
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    checkedRowIds: [],
    frozenColumns: [],
    hiddenColumns: [],
  });

  const type = [
    { id: 1, name: 'All' },
    { id: 2, name: 'My Prospects' },
    { id: 3, name: 'Department Wise' },
    { id: 4, name: 'Assigned To Me' },
  ];
  const [selectedType, setSelectedType] = useState(isDeptOgdOrCsd ? (!isHod || !isReportingHead ? 2 : 3) : 3);
  const isActionDisabled = selectedType == 1 ? true : false;

  useEffect(() => {
    dispatch(getSyllabus());
    dispatch(getClass());
    dispatch(getProspectLeadStatuses());
  }, []);

  // const dispatchParams = useMemo(
  //   () => ({
  //     page: tableState.page,
  //     limit: tableState.pageSize,
  //     search: tableState.search || '',
  //     // status: selectedStatus || '',
  //     status: selectedStatus === 'all' ? undefined : selectedStatus,
  //     project: selectedProject === 'all' ? undefined : selectedProject,
  //     type:
  //       selectedType == 1
  //         ? 'all'
  //         : selectedType == 2
  //           ? 'myProspects'
  //           : selectedType == 3
  //             ? 'departmentWise'
  //             : 'assignedToMe',
  //   }),
  //   [tableState.page, tableState.pageSize, tableState.search, selectedType, selectedStatus, selectedProject],
  // );
  const dispatchParams = useMemo(() => {
    // Find the project object to get the string label
    const selectedProjectObj = project.find((p) => p.id === selectedProject);

    return {
      page: tableState.page,
      limit: tableState.pageSize,
      search: tableState.search || '',
      status: selectedStatus === 'all' ? null : selectedStatus,
      //   Send the string label (e.g., "Little Genie") instead of ID
      project: selectedProject === 'all' ? null : selectedProjectObj?.label,

      type:
        selectedType == 1
          ? 'all'
          : selectedType == 2
            ? 'myProspects'
            : selectedType == 3
              ? 'departmentWise'
              : 'assignedToMe',
    };
  }, [tableState.page, tableState.pageSize, tableState.search, selectedType, selectedStatus, selectedProject]);
  useEffect(() => {
    dispatch(getProspectLeadsTable(dispatchParams));
  }, [dispatch, dispatchParams]);

  //status
  const { leadStatuses } = useSelector((state) => state.global);

  const handleRefreshParams = useMemo(() => ({ ...dispatchParams, hardRefresh: true }), [dispatchParams]);
  const headers = useMemo(() => {
    return ProspectLeadsTableHeader(isDeptOgdOrCsd, isActionDisabled);
  }, [isDeptOgdOrCsd, isActionDisabled]);
  const handleRefresh = useCallback(() => {
    dispatch(getProspectLeadsTable(handleRefreshParams));
  }, [dispatch, handleRefreshParams]);

  //refersh logic + close
  const closeModal = useCallback(
    (shouldRefresh = false) => {
      setModalState({ actionKey: '', row: null });

      if (shouldRefresh) {
        handleRefresh();
      }
    },
    [handleRefresh],
  );

  const [modalState, setModalState] = useState({
    actionKey: '',
    row: null,
  });
  const handleButtonActionClick = useCallback((actionKey, row, actionType) => {
    if (!actionKey || !row) return;

    setModalState({
      actionKey,
      row,
    });
  }, []);

  const modalConfigs = useMemo(
    () => [
      {
        actionKey: 'addLead',
        title: 'Add Lead',
        render: () => <ProspectLeadAddEdit onClose={closeModal} />,
      },
      {
        actionKey: 'editLead',
        title: 'Edit Lead',
        render: ({ row }) => <ProspectLeadAddEdit row={row} onClose={closeModal} />,
      },
      {
        actionKey: 'assignLead',
        title: 'Assign Lead',
        render: ({ row }) => (
          <LeadAssignUpdate row={row} checkedRowIds={tableState.checkedRowIds} onClose={closeModal} />
        ),
      },

      {
        actionKey: 'transferLead',
        title: 'Transfer To Department',
        render: ({ row }) => <LeadTransferUpdate row={row} onClose={closeModal} />,
      },
      {
        actionKey: 'statusLead',
        title: 'Update Status',
        render: ({ row }) => <LeadStatusUpdate row={row} onClose={closeModal} />,
      },
      // {
      //   actionKey: 'deleteLead',
      //   title: 'Delete Lead',
      //   render: ({ row }) => (
      //     <DeleteButton action={() => handleDelete(row)} variant="outlined">
      //       Confirm Delete
      //     </DeleteButton>
      //   ),
      // },
      {
        actionKey: 'viewLead',
        title: 'View History',
        render: ({ row }) => <LeadViewHisory row={row} />,
      },
    ],
    [tableState.checkedRowIds, closeModal],
  );

  const activeConfig = useMemo(
    () => modalConfigs.find((config) => config.actionKey === modalState.actionKey),
    [modalConfigs, modalState.actionKey],
  );

  return (
    <GlobalWrapper title={'Prospect Leads'}>
      <Box mt={1}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          // sx={{
          //   flexWrap: 'wrap', // Allows wrapping into multiple rows
          //   rowGap: 2, // Adds vertical space when wrapped
          // }}
        >
          {/* 1. Type Select */}
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
              select
              size="small"
              label="Type"
              value={selectedType}
              onChange={(e) => setSelectedType(e.target.value)}
              sx={{
                minWidth: { xs: '100%', sm: 180, md: 220 },
              }}
            >
              {type.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              select
              size="small"
              label="Status"
              value={selectedStatus}
              sx={{
                minWidth: { xs: '100%', sm: 180, md: 220 },
              }}
              onChange={(e) => {
                setSelectedStatus(e.target.value);
                setTableState((prev) => ({ ...prev, page: 1 }));
              }}
            >
              <MenuItem value="all">All</MenuItem>
              {leadStatuses.map((item) => (
                <MenuItem key={item.sro_lead_status_id} value={item.sro_lead_status_id}>
                  {item.sro_lead_status_name}
                </MenuItem>
              ))}
            </TextField>
            {/* project */}
            <TextField
              select
              size="small"
              label="Project"
              value={selectedProject}
              sx={{
                minWidth: { xs: '100%', sm: 180, md: 220 },
              }}
              onChange={(e) => {
                setSelectedProject(e.target.value);
                setTableState((prev) => ({ ...prev, page: 1 }));
              }}
            >
              <MenuItem value="all">All</MenuItem>
              {project.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.label}
                </MenuItem>
              ))}
            </TextField>
          </Stack>
          {/* 2. Add Lead Button */}
          <Stack direction="row" spacing={1}>
            <AssignButton
              type="add"
              label="Add Lead"
              fullWidth
              onClick={() => setModalState({ actionKey: 'addLead', row: null })}
            />

            {/* 3. Bulk Upload */}

            <ProspectLeadsBulkUpload params={dispatchParams} refreshTable={handleRefresh} />

            {/* 4. Bulk Assign Button */}

            <AssignButton
              type="assign"
              label="Bulk Assign"
              fullWidth
              disabled={
                isActionDisabled ||
                tableState.checkedRowIds.length === 0 ||
                !isDeptOgdOrCsd ||
                (isDeptOgdOrCsd && !isHod && !isReportingHead)
              }
              onClick={() =>
                setModalState({
                  actionKey: 'assignLead',
                  row: null,
                })
              }
            />
          </Stack>
          {/* </Stack> */}
        </Stack>
        <Paper elevation={3}>
          <Box mt={2}>
            <GlobalTable
              rowUniqueId="prospect_lead_id"
              // headers={ProspectLeadsTableHeader(isDeptOgdOrCsd, isActionDisabled)}
              headers={headers}
              tableState={tableState}
              setTableState={setTableState}
              checkboxNeeded={isDeptOgdOrCsd}
              loading={loading}
              rows={data}
              meta={meta}
              onButtonActionClick={handleButtonActionClick}
              // exportApi={getProspectLeadsTable}
              exportUrl="prospect-leads"
              exportParams={{ ...dispatchParams, page: 1, limit: 'no' }}
            />
          </Box>
          <Box>
            <GlobalDialog
              title={activeConfig?.title}
              open={Boolean(modalState?.actionKey)}
              setOpen={(val) => {
                if (!val) setModalState({ actionKey: '', row: null });
              }}
              closeButton={true}
              content={activeConfig?.render ? activeConfig.render({ row: modalState.row }) : null}
              maxWidth={activeConfig?.actionKey === 'viewLead' ? 'lg' : 'md'}
              fullWidth={true}
            />
          </Box>
        </Paper>
      </Box>
    </GlobalWrapper>
  );
};

export default ProspectLeads;
